import React, { useEffect, useState } from 'react';
import {Form, Button, Card} from 'react-bootstrap'
import './Reports.css'
import StampPaper from './RaiseRequest/stamppaper';
import EFranking from './RaiseRequest/e_franking';
import ESignIn from './RaiseRequest/e_sign';
import EStampPaper from './RaiseRequest/e_stamp_paper';
import Franking from './RaiseRequest/franking';
import Notary from './RaiseRequest/notary';
import axios from 'axios';
import GiftingDeliveryforEducators from './RaiseRequest/GiftingDeliveryforEducators'
import BithdaysandanniversariesTrac from './RaiseRequest/BithdaysandanniversariesTrac';
import EducatorDelight_Adminsheet from './RaiseRequest/EducatorDelight_Adminsheet';
import LogisticEducatorDelightGift from './RaiseRequest/LogisticEducatorDelightGift';
import {useHistory} from 'react-router-dom';
import UserDetailsSelect from './LandingPage/UserDetailsSelect.js'

let serviceName='';
const RaiseRequest=(props)=>{

    let [scheme, setscheme]=useState([])
  let [call_log_user, setget_call_log_user]=useState({})
 let [selected_scheme, setselected_sceme]=useState('')
    let [selected_scheme_name, set_selected_scheme_name] = useState('')

    const [finishStatus, setfinishStatus] = useState(false);

    let [propsData, setpropsData]=useState(props)
    const history=useHistory()
    try{
        if(history.location.props){
            let npropsData={...propsData}
            npropsData.userData=history.location.props
            propsData=npropsData
        }
    }
    catch(err){}
    try{
        if(history.location.state.serviceName){
            serviceName=history.location.state.serviceName
        }else{
            serviceName=''
        }
    }
    catch(err){}
    console.log('propsData',propsData)
    const [allservices, setallservices]=useState([])
    // let allservices=['Stamp Paper', 'E-Stamp Paper', 'Franking', 'E-Franking', 'Notary', 'E-Sign', "Gifting Delivery for Educators"]
    const [services, setservices]=useState(serviceName)

    
    const fetchAllScheme=()=>{
        axios.get('/get_schemes_stamp_paper').then((res)=>{
            res.data.data.forEach(key=>{
                if(JSON.parse(key.id)===JSON.parse(propsData.userData.corporate_id)){
                    set_selected_scheme_name(key.scheme_name)
                        console.log('dssms', key)
                        if(key.scheme_name==='Unacademy'){
                            setallservices(['Bithdays and anniversaries Trac', 'Educator Delight - Admin sheet','Logistic Educator Delight Gift'])
                        }else{
                            setallservices(['Stamp Paper', 'E-Stamp Paper', 'Franking', 'E-Franking', 'Notary', 'E-Sign'])
                            console.log('vjhgj', key)
                        }
                    }
                    else if(JSON.parse(propsData.userData.corporate_id)===1){
                        setallservices(['Stamp Paper', 'E-Stamp Paper', 'Franking', 'E-Franking', 'Notary', 'E-Sign', "Gifting Delivery for Educators", 'Bithdays and anniversaries Trac', 'Educator Delight - Admin sheet','Logistic Educator Delight Gift'])

                    }
                })
            // setscheme(res.data.data)
          })
    }
    const returnComponent=()=>{
        switch (services) {
            case 'Stamp Paper':
                    return(<StampPaper servicetype={services} userData={propsData.userData}/>)
                break;
                case 'E-Stamp Paper':
                    return(<EStampPaper servicetype={services} userData={propsData.userData}/>)
                break;
                case 'Franking':
                    return(<Franking servicetype={services} userData={propsData.userData}/>)
                break;
                case 'E-Franking':
                    return(<EFranking servicetype={services} userData={propsData.userData}/>)
                break;
                case 'Notary':
                    return(<Notary servicetype={services} userData={propsData.userData}/>)
                break;
                case 'E-Sign':
                    return(<ESignIn servicetype={services} userData={propsData.userData}/>)
                break;
                case 'Gifting Delivery for Educators':
                    return(<GiftingDeliveryforEducators servicetype={services} userData={propsData.userData}/>)
                break;
                case 'Bithdays and anniversaries Trac':
                    return(<BithdaysandanniversariesTrac servicetype={services} userData={propsData.userData}/>)
                break;
                case 'Educator Delight - Admin sheet':
                    return(<EducatorDelight_Adminsheet servicetype={services} userData={propsData.userData}/>)
                break;
                case 'Logistic Educator Delight Gift':
                    return(<LogisticEducatorDelightGift servicetype={services} userData={propsData.userData}/>)
                break;
            default:
                return(<StampPaper servicetype={services} userData={propsData.userData}/>)
                break;
        }
    }
 
const onBackButtonEvent = (e) => {
    if(serviceName!==''){
        e.preventDefault();
        if (!finishStatus) {
            if (window.confirm("Do you want to go back ?")) {
                setfinishStatus(true)
                // your logic
                history.go(0)
            } else {
               
                setfinishStatus(false)
            }
        }
    }
}

    useEffect(()=>{
       
        window.addEventListener('popstate', onBackButtonEvent);
        return () => {
        window.removeEventListener('popstate', onBackButtonEvent);  
        
        }
    }, [])
    useEffect(()=>{
        fetchAllScheme()
    }, [])
    return(
        <div className='ContainerCard' style={{
            paddingTop:serviceName!==''?60:0,
            minHeight:400
        }}>
            {serviceName===''&&
            <div className="Report" style={{display:'flex', alignItems:'center', justifyContent:'space-around'}}>
                    
                    <div></div>
                    <div>
                        <p>Raise Request For &nbsp;{selected_scheme_name}
                         {services!==''&& "for "+services}</p>

                        {/* <UserDetailsSelect /> */}
                    </div>
                    <div>
                        <Button onClick={()=>{
                            setservices('')

                        }} style={{background:'none', border:0}}>
                            <img style={{
                                height:40,
                                filter:'brightness(0) invert(1)'
                            }}
                             src={require('../images/back.png').default}/>
                        </Button>
                    </div>
            </div>
            }
            {serviceName!==''&&
                <div >
                    <h3 style={{
                        textAlign:'center',
                        fontWeight:'bold'
                    }}>Raise Request of {serviceName}</h3>
                </div>
            }
        <Card className="Container2" style={{
            border:0,
            background:'transparent',
            width:'100%'
        }}>
        {services===''?
            <div>
              
              {/*
                <div className="container2">
                      <div className="box" >
                      <img style={{
                          height:80, width:80, 
                          borderRadius:'50%'
                      }} src={require('../images/logo.jpeg').default}/>
                      </div>
                      <div className="box stack-top" style={{background:'#FFF', marginLeft:80}}>
                      <span style={{background:'#FFF', height:90}}>Stamp Paper</span>
                      </div>
                  </div>
            */}
            <div className='grid_container_raise_req' style={{marginTop:10}}>
                {allservices.map((allservicesdata, i)=>{
                    return(

                        <div onClick={()=>{
                            setservices(allservicesdata)
                        }} key={i} className='grid_item_raise_req'>
                            <div>
                                <img style={{
                                    height:80, width:80, 
                                    borderRadius:'50%'
                                }} src={require('../images/logo.jpeg').default}/>
                            </div>
                            <div style={{textAlign:'center'}}>
                                <span>{allservicesdata}</span>
                            </div>
                        </div>
                    )
                })}
            </div>

            </div>
            :
            <div>
                {returnComponent()}
            </div>
            }
        </Card>
    </div>

    )
}
export default RaiseRequest;